function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAddOnSuccess = function SvgIconAddOnSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 386.6,
    style: {
      fill: "#d70b17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.3 556.9 98.5 102.5 261.4-253.6",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 90,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }));
};
export default SvgIconAddOnSuccess;